export default function(title) {
    let separator = '-';

    if (!title) {
        title = [];
    }
    else if ( !Array.isArray(title) ) {
        title = [title];
    }

    title.push('Медитации на български');
    title.push('Медита.бг');

    return title.join(' ' + separator + ' ');
}


// WEBPACK FOOTER //
// ./src/utils/TitleBuilder.js